import React from 'react'
import styles from './style/grid_style.module.scss';
import PropTypes from 'prop-types'

const CELL_PROPTYPES = {
    'col-1': PropTypes.bool,
    'col-2': PropTypes.bool,
    'col-3': PropTypes.bool,
    'col-4': PropTypes.bool,
    'col-5': PropTypes.bool,
    'col-6': PropTypes.bool,
    'col-7': PropTypes.bool,
    'col-8': PropTypes.bool,
    'col-9': PropTypes.bool,
    'col-10': PropTypes.bool,
    'col-11': PropTypes.bool,
    'col-12': PropTypes.bool,
    'center': PropTypes.bool,
    'start': PropTypes.bool,
    'end': PropTypes.bool
}

const Cell = ({ children, ...props }) => {

    const getClasses = () => {
        const propKeys = Object.keys(props)
        const _classes = []

        propKeys.reduce((classes, prop) => {
            const classProp = CELL_PROPTYPES[prop] && styles[prop]
            if (classProp) classes.push(classProp)
            if (prop === 'className') classes.push(props.className)
            return classes
        }, _classes)

        return _classes.join(' ')
    }

    const classes = getClasses()

    return React.cloneElement(children, {className: classes})
};

Cell.propTypes = CELL_PROPTYPES

export default Cell;